var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 13 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001D52",
    d: "M6.509 7.458a3.546 3.546 0 0 1-3.542-3.541A3.546 3.546 0 0 1 6.51.375a3.546 3.546 0 0 1 3.541 3.542A3.546 3.546 0 0 1 6.51 7.458m0-5.833a2.294 2.294 0 0 0-2.292 2.292A2.294 2.294 0 0 0 6.51 6.208 2.294 2.294 0 0 0 8.8 3.917 2.294 2.294 0 0 0 6.51 1.625m3.323 15H3.171c-2.017 0-3.128-1.104-3.128-3.11 0-2.217 1.255-4.807 4.792-4.807h3.333c3.537 0 4.792 2.59 4.792 4.808 0 2.005-1.111 3.109-3.128 3.109M4.835 9.958c-3.286 0-3.542 2.723-3.542 3.558 0 1.303.562 1.859 1.878 1.859h6.661c1.316 0 1.878-.556 1.878-1.86 0-.833-.256-3.557-3.542-3.557z"
  })));
};
export default SvgUser;